import { PlusIcon } from "components/atoms/Icon";
import useMeasureSidebarState from "recoilStore/CustomPlan/useMeasureSidebarState";
import { Paragraph } from "components/atoms/Typography";
import styles from "./EditCustomPlanButton.module.scss";

function AddMeasureButton() {
    const { setState: setMeasureSidebarState } = useMeasureSidebarState();

    return (
        <button
            className={styles.addProjectButton}
            type="button"
            onClick={() =>
                setMeasureSidebarState((prevState) => ({
                    ...prevState,
                    isCreateOpen: true,
                }))
            }
        >
            <PlusIcon height={12} />
            <Paragraph>Add Measure</Paragraph>
        </button>
    );
}

export default AddMeasureButton;
